import * as CompanyActions from "./company.actions";
import { createReducer, on } from "@ngrx/store";
import { recursive as mergeRecursive } from "merge";
import { CompanyState } from "./company.state";

const initialState: CompanyState = {
    currentCompany: null,
};

export const CompanyReducer = createReducer(
    initialState,
    on(CompanyActions.ExtendStateAction, (state, { newState }) => ({ ...state, ...newState })),
    on(CompanyActions.MergeStateAction, (state, { newState }) => mergeRecursive(true, state, newState)),
);
